<template>
  <div class="mailList">
    <div class="FirstLevelTitle titleDiv">
      <div>{{ title }}</div>
    </div>

    <div class="card" v-for="tel in telList" :key="tel.id">
      <div class="cardList">
        <!-- <div class="name">{{ tel.department }}：{{ tel.name }}</div>
        <div class="telDiv clearfix">
          <div class="tel">联系方式：{{ tel.tel }}</div>
          <div
            class="telIconDiv"
            @click="
              () => onHeaderDetailActionClick({ action: 'tel', tel: tel.tel })
            "
          >
            <img
              src="../../assets/image/btn_dianhua_nor.png"
              alt="电话"
              class="telIcon"
            />
          </div>
        </div> -->
        <div class="description">办事指引：<div v-html="tel.content"></div></div>
        <!-- <el-divider></el-divider> -->
      </div>
    </div>

    <van-action-sheet
      v-model="isDialActive"
      :actions="[{ name: `联系人电话：${phone}` }]"
      cancel-text="取消"
      close-on-click-action
      @select="onDialogActionSelect"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      listName: [],
      activeNames: [],
      telList: [],
      isDialActive: false,
      phone: "",
      title: "办事指南",
    };
  },
  created() {
    this.getTel();
  },
  methods: {
    // async getList() {
    //   const result = await this.$http.get("/addressBook/getDept");
    //   // this.listName = result.data;
    //   console.log("this.listName", this.listName[0]);
    //   for(var i = 0; i < result.data.length; i++){
    //     if(result.data[i].post == '办事指南'){
    //       this.listName.push(result.data[i]);
    //     }
    //   }
    //   this.getTel();
    // },
    async getTel() {
      const result = await this.$http.post(
        "/addressBook/getContactInformation"
      );
      for (var i = 0; i < result.data.length; i++) {
        if (result.data[i].post == this.title) {
          this.telList.push(result.data[i]);
        }
      }
    },
    // 拨打电话
    onHeaderDetailActionClick(action) {
      console.log("action", action);
      this.phone = action.tel;
      const actionMap = {
        tel: () => {
          this.isDialActive = true;
        },
        qrcode: () => {
          this.isQrCodeActive = true;
        },
      };
      actionMap[action.action]();
    },
    onDialogActionSelect() {
      const link = document.createElement("a");
      link.href = `tel:${this.phone}`;
      link.click();
    },
  },
};
</script>
<style lang="less" scoped>
.list {
}
.titleDiv {
  margin-left: 2.5vw;
  height: 7vw;
  display: flex;
  width: 90%;
  margin-top: 20px;
  .titleIcon {
    width: 4px;
    height: 6vw;
    background-color: #00706e;
    border-radius: 15px;
  }
  .titleWord {
    padding-left: 10px;
    font-size: 1rem;
    font-weight: bold;
    color: #333333;
  }
}
.card {
  position: relative;
  width: 95vw;
  background: #ffffff;
  border: 1px solid #dcdfe6;
  border-radius: 15px;
  margin: 10px 0 10px 2.5vw;

  .name,
  .email {
    // font-weight: 510;
    color: #585858;
    font-size: 0.9rem;
    margin: 10px 0px 10px 10px;
  }
  .telDiv {
    position: relative;
    left: 10px;
    margin: 10px 0;
    .tel {
      float: left;
      // font-weight: 520;
      color: #585858;
      font-size: 0.9rem;
    }
    .telIconDiv {
      float: left;
      width: 12px;
      margin-left: 5px;
      .telIcon {
        // width: 100%;
        // padding-top: 3px;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}

.el-divider {
  position: relative;
  left: 3%;
  width: 94%;
}
.van-collapse {
  margin-top: 10px;
}
.van-cell__title {
  .span {
    font-weight: bold;
    color: #333333;
  }
}
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  *zoom: 1;
}
.description {
  margin: 10px 0px 10px 10px;
  color: #585858;
  font-size: 0.9rem;
  font-weight: 400;
  word-wrap: break-word;
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/components/service/ServiceTips.vue